var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.375V0H1.125A1.11 1.11 0 0 0 0 1.125v21.75A1.08 1.08 0 0 0 1.125 24h15.75A1.11 1.11 0 0 0 18 22.875V7.5h-6.375A1.08 1.08 0 0 1 10.5 6.375zm3.047 10.172H10.5v3.75a.81.81 0 0 1-.75.75h-1.5c-.422 0-.75-.375-.75-.75v-3.75H4.406c-.656 0-.984-.844-.516-1.312l4.5-4.5a.92.92 0 0 1 1.172 0l4.5 4.5c.469.469.141 1.313-.516 1.313zm4.125-11.625L13.078.328C12.844.141 12.563 0 12.281 0H12v6h6v-.281c0-.281-.141-.562-.328-.797z",
    fill: "#575756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.19f9ec3088f48ff32557a6daa6dc367c.svg";
export { ForwardRef as ReactComponent };